<template>
   <table class="table bg-white table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th class="font-weight-bold"><h6> {{ translate('Name') }}</h6></th>
                            <th class="font-weight-bold"><h6> {{ translate('Harmonic Mean') }}</h6></th>
                            <th class="font-weight-bold"><h6> {{ translate('Mean') }}</h6></th>
                            <th class="font-weight-bold"><h6> {{ translate('Max') }}</h6></th>
                            <th class="font-weight-bold"><h6> {{ translate('Min') }}</h6></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <span>Integer Adm2
                                    <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerAdm2Text }}</template> 
                                    </Tooltip>
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm2.harmonic_mean}}
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm2.mean}}
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm2.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm2.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Adm Scale 0
                                    <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerAdmScaleText }}</template> 
                                    </Tooltip>
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale0.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale0.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale0.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale0.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Adm Scale 1
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerAdmScaleText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale1.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale1.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale1.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale1.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Adm Scale 2
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerAdmScaleText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale2.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale2.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale2.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale2.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Adm Scale 3
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerAdmScaleText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale3.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale3.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale3.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_adm_scale3.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Motion
                                    <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerMotionText }}</template> 
                                    </Tooltip>
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Motion 2
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerMotionText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion2.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion2.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion2.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_motion2.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Vif Scale 0
                                    <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerVifScaleText }}</template> 
                                    </Tooltip>
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale0.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale0.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale0.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale0.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Vif Scale 1
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerVifScaleText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale1.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale1.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale1.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale1.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Vif Scale 2
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerVifScaleText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale2.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale2.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale2.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale2.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Integer Vif Scale 3
                                    <!-- <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ integerVifScaleText }}</template> 
                                    </Tooltip> -->
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale3.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale3.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale3.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.integer_vif_scale3.min}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Vmaf
                                    <Tooltip position="right">
                                        <template v-slot:icon><i class="far fa-info-circle text-info  text-info cursor-pointer"></i></template>
                                        <template v-slot:tooltip-content> {{ vmafText }}</template> 
                                    </Tooltip>
                                </span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.vmaf.harmonic_mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.vmaf.mean}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.vmaf.max}}</span>
                            </td>
                            <td>
                                <span>{{ this.pooledMetrics.vmaf.min}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
</template>
<script>
import { translate } from '../../../../helper/translate';
import Tooltip from '../form/Tooltip';
export default {
   name: 'VideoQualityFactorTable',
   components:{Tooltip},
   data(){
    return{
        integerAdm2Text: translate(
                           'The Average Difference Modulus (ADM) metric, which measures the average difference between the two videos in terms of pixel intensity.'
                        ),
            integerAdmScaleText: translate('The ADM metric calculated at a lower resolution.'),
            integerMotionText: translate('The Motion metric, which measures the degree of motion in the video.'),
            integerVifScaleText: translate('The Visual Information Fidelity (VIF) metric calculated at a lower resolution.'),
            vmafText: translate('The VMAF score is calculated on a per-frame basis and the vmaf field in the metrics field contains the VMAF score for each individual frame.'),
    }
   },

   props: {
       pooledMetrics: Object,
   },
   filters: {
       trans(msg) {
           return translate(msg);
       },
   },
};

</script>
<style></style>